import { Flex, EStepState, StepCard } from '@kognitos/lattice';
import type { IDialogStepperProps } from './types';

/**
 * Determines the step state based on current step and step number
 */
const getStepState = (stepNumber: number, currentStep: number): EStepState => {
  if (stepNumber < currentStep) return EStepState.Pending;
  if (stepNumber === currentStep) return EStepState.Active;
  return EStepState.Pending;
};

/**
 * DialogStepper Component
 *
 * A horizontal stepper component that displays multiple steps with their
 * current state (active, completed, or disabled).
 *
 * @param props - Component props
 * @returns JSX element containing the stepper
 */
export function DialogStepper({
  steps,
  currentStep,
  onStepClick,
}: IDialogStepperProps) {
  return (
    <Flex direction="row" gap={3} className="w-full">
      {steps.map(step => (
        <StepCard
          key={step.number}
          stepNumber={step.number}
          label={step.title}
          description={step.description}
          state={getStepState(step.number, currentStep)}
          onClick={onStepClick ? () => onStepClick(step.number) : undefined}
        />
      ))}
    </Flex>
  );
}
